import { APIProposalStatus } from "../api/proposals";
import { states } from "./constants";
import apiRequest from "./requests";

function formatMoney(amount: number): string {
  const formatter = new Intl.NumberFormat('en-US', { 
    style: 'currency', 
    currency: 'USD' 
  });
  return formatter.format(amount)
}

function formatDateString(d: Date): string {
  return `${d.getMonth()+1}/${d.getDate()}/${d.getFullYear()}`;
}

function statusToColor(s: APIProposalStatus): "warning" | "error" | "success" | "primary" {
  switch (s) {
    case "QUOTED":
      return "warning"
    case "LEAD":
      return "error"
    case "WON":
      return "success"
    case "DONE":
      return "primary"
  }
}

export { apiRequest, formatMoney, states, formatDateString, statusToColor };
